/* RESPONSIBLE TEAM: team-inbox */
import { hasFeature } from 'embercom/helpers/has-feature';
import type IntlService from 'embercom/services/intl';
import type PermissionsModal from 'embercom/services/permissions-modal';
import type Session from 'embercom/services/session';

interface CheckConversationCreationPermissionParams {
  appService: any;
  permissionsModal: PermissionsModal;
  intl: IntlService;
  session?: Session;
}

export function checkConversationCreationPermission({
  appService,
  permissionsModal,
  intl,
  session,
}: CheckConversationCreationPermissionParams): boolean {
  if (!hasFeature('spg-inbox-manage-conversation-creation', appService, session)) {
    return true;
  }

  if (!appService.app.currentAdmin?.canManageConversationCreation) {
    permissionsModal.showModal({
      permissionsLabel: intl.t('inbox.conversation-header.create-conversation-permission-label'),
    });
    return false;
  }

  return true;
}
